import { render, staticRenderFns } from "./ShopStockItemByCategory.vue?vue&type=template&id=da325538"
import script from "./ShopStockItemByCategory.vue?vue&type=script&lang=js"
export * from "./ShopStockItemByCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da325538')) {
      api.createRecord('da325538', component.options)
    } else {
      api.reload('da325538', component.options)
    }
    module.hot.accept("./ShopStockItemByCategory.vue?vue&type=template&id=da325538", function () {
      api.rerender('da325538', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/shop/src/views/ShopStockItemByCategory.vue"
export default component.exports